export enum UserGenderEnum {
  MALE = 0,
  FEMALE = 1,
  NOT_INFORMED = 2,
  OTHER = 3,
}

export const UserGenderLabels: Record<UserGenderEnum, string> = {
  [UserGenderEnum.MALE]: "Masculino",
  [UserGenderEnum.FEMALE]: "Feminino",
  [UserGenderEnum.NOT_INFORMED]: "Não Informado",
  [UserGenderEnum.OTHER]: "Outro",
};

export const USER_GENDER_OPTIONS = [
  { value: "0", label: UserGenderLabels[UserGenderEnum.MALE] },
  { value: "1", label: UserGenderLabels[UserGenderEnum.FEMALE] },
  { value: "2", label: UserGenderLabels[UserGenderEnum.OTHER] },
];

export default UserGenderEnum;
